var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStreetviewColor = function SvgStreetviewColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.1144C18 15.4311 15.3137 14.0665 12 14.0665C8.6862 14.0665 6 15.4311 6 17.1144C6 18.4989 7.81861 19.666 10.3076 20.0374L12 22L13.6924 20.0374C16.1812 19.666 18 18.4989 18 17.1144Z",
    fill: "#B9DAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5731 4.48456C14.5731 5.85675 13.4211 6.96913 12 6.96913C10.5789 6.96913 9.42682 5.85675 9.42682 4.48456C9.42682 3.11238 10.5789 2 12 2C13.4211 2 14.5731 3.11238 14.5731 4.48456Z",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9028 12.9302H9.09731C8.84081 12.9302 8.63287 12.7294 8.63287 12.4818V8.88512C8.63287 8.14711 9.25248 7.54883 10.0168 7.54883H13.9833C14.7476 7.54883 15.3672 8.14711 15.3672 8.88512V12.4818C15.3672 12.7294 15.1593 12.9302 14.9028 12.9302Z",
    fill: "#007AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9436 17.2853H11.0566L10.0273 11.2334H13.9728L12.9436 17.2853Z",
    fill: "#007AFF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStreetviewColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "streetview-color.d0193e8f2230f6700e8b5a9645ace825.svg";